import React from 'react';
import { Users, ChefHat } from 'lucide-react';
import { Card } from './ui/card';

const Catering = () => {
  const cateringOptions = [
    {
      size: 'Full/Large Pan',
      dimensions: '20.7" x 12.8" x 3.18"',
      serves: '40-45 people',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/76wz8sma_Mac%20%26%20Cheese%20Large.jpg',
      alt: 'Large Mac & Cheese Pan'
    },
    {
      size: 'Half/Small Pan',
      dimensions: '12.8" x 10.3" x 2.48"',
      serves: '10-12 people',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/0mj6k2rk_Small-Mac%26Cheese.jpg',
      alt: 'Small Mac & Cheese Pan'
    }
  ];

  const cateringItems = [
    {
      name: 'Honey Garlic Ribs',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/gg9ap55t_Honey%20Garlic%20Ribs.jpg',
      description: 'Tender ribs glazed with our signature honey garlic sauce'
    },
    {
      name: 'Red Snapper Platter',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/vvolh23o_Red-Snapper-platter.jpg',
      description: 'Fresh red snapper served with vegetables and sides'
    },
    {
      name: 'Fish & Vegetables',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/thvtz27a_fish-veg.png',
      description: 'Grilled fish with fresh seasonal vegetables'
    }
  ];

  return (
    <section id="catering" className="catering-section">
      <div className="catering-container">
        <div className="section-header">
          <span className="section-badge">Catering Services</span>
          <h2 className="section-title">Perfect for Your Special Events</h2>
          <p className="section-description">
            Bring authentic Caribbean flavors to your next gathering. Our catering options are perfect for 
            family reunions, parties, corporate events, and celebrations of all sizes.
          </p>
        </div>

        <div className="catering-sizes">
          <h3 className="catering-subtitle">Pan Sizes & Servings</h3>
          <div className="catering-sizes-grid">
            {cateringOptions.map((option, index) => (
              <Card key={index} className="catering-size-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="catering-size-image-wrapper">
                  <img 
                    src={option.image} 
                    alt={option.alt}
                    className="catering-size-image"
                  />
                  <div className="catering-size-badge">{option.size}</div>
                </div>
                <div className="catering-size-info">
                  <div className="catering-size-icon">
                    <ChefHat size={32} />
                  </div>
                  <h4 className="catering-size-title">{option.size}</h4>
                  <div className="catering-size-details">
                    <p className="catering-dimensions">{option.dimensions}</p>
                    <div className="catering-serves">
                      <Users size={20} />
                      <span>Feeds {option.serves}</span>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        <div className="catering-items-section">
          <h3 className="catering-subtitle">Featured Catering Items</h3>
          <div className="catering-items-grid">
            {cateringItems.map((item, index) => (
              <Card key={index} className="catering-item-card" style={{ animationDelay: `${index * 0.15}s` }}>
                <div className="catering-item-image-wrapper">
                  <img 
                    src={item.image} 
                    alt={item.name}
                    className="catering-item-image"
                  />
                </div>
                <div className="catering-item-info">
                  <h4 className="catering-item-name">{item.name}</h4>
                  <p className="catering-item-description">{item.description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>

        <div className="catering-video-section">
          <h3 className="catering-subtitle">Fresh from Our Kitchen</h3>
          <div className="catering-video-wrapper">
            <video 
              className="catering-video"
              controls
              poster="https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/5jqgzoou_video-thumbnail.jpg"
            >
              <source src="https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/i3xpvmu5_Hot-Out-The-Oven.MP4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="video-caption">Watch our delicious Caribbean meals being prepared fresh - hot out the oven!</p>
          </div>
        </div>

        <div className="catering-cta">
          <div className="catering-cta-box">
            <h3>Ready to Cater Your Event?</h3>
            <p>Contact us to discuss your catering needs and get a custom quote for your special occasion.</p>
            <a href="#footer" className="catering-contact-btn">Contact Us for Catering</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Catering;
